import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase, faStop, faFileCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { setSelectedJobType } from '../features/jobs/jobSlice'
import { useNavigate, useParams } from 'react-router-dom';
export default function Sidebar() {

    const dispatch = useDispatch();

    const handleClick = (jobType) => {
        dispatch(setSelectedJobType(jobType));
    };
    const navigate = useNavigate();
    const goToHome = () => {
        navigate("/");
    }
    return (
        <div className="sidebar">
            <nav>
                <ul className="space-y-4">
                    <li>
                        <a to="/" className="main-menu menu-active" id="lws-alljobs-menu" onClick={(e) => { e.preventDefault(); goToHome(); handleClick('') }}>
                            {/* <i className="fa-solid fa-briefcase"></i> */}
                            <FontAwesomeIcon icon={faBriefcase} />
                            <span> All Available Jobs</span>
                        </a>
                        <ul className="space-y-6 lg:space-y-2 ">
                            <li>
                                <a className="sub-menu" href="#" id="lws-internship-menu" onClick={(e) => { e.preventDefault(); handleClick('Internship') }}>
                                    <FontAwesomeIcon icon={faStop} /> Internship
                                </a>
                            </li>
                            <li>
                                <a className="sub-menu" href="/jobs/fulltime" id="lws-fulltime-menu" onClick={(e) => { e.preventDefault(); handleClick('Full Time') }}>
                                    <FontAwesomeIcon icon={faStop} /> Full Time
                                </a>
                            </li>
                            <li>
                                <a className="sub-menu" href="/jobs/remote" id="lws-remote-menu" onClick={(e) => { e.preventDefault(); handleClick('Remote') }}>
                                    <FontAwesomeIcon icon={faStop} /> Remote
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/create" className="main-menu" id="lws-addJob-menu">
                            <FontAwesomeIcon icon={faFileCirclePlus} /> <span>Add NewJob</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}
